export {
	default as ExternalLinksStateless,
	EXTERNAL_LINKS_TO_BE_SHOWN,
} from './external-links-stateless';
